import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=38acb9bf&scoped=true"
import script from "./Debug.vue?vue&type=script&lang=js"
export * from "./Debug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acb9bf",
  null
  
)

export default component.exports